import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  data: null,
};

const InvitationSlice = createSlice({
  name: 'InvitationData',
  initialState,
  reducers: {
    addItem: (state, action) => {
      if(state.data === null)
        state.data = [];
      state.data.push(action.payload);
    },
    setItems: (state, action) => {
      state.data = action.payload;
    },
    removeItem: (state, action) => {
      state.data = state.data.filter(item => item.id !== action.payload);
    },
    updateItem: (state, action) => {
      const { id, ...changes } = action.payload;
      const index = state.data.findIndex(item => item.id === id);
      if (index !== -1) {
        state.data[index] = { ...state.data[index], ...changes };
      }
    },
  },
});

export const { addItem, setItems, removeItem, updateItem } = InvitationSlice.actions;

export default InvitationSlice.reducer;
